module.exports = __webpack_public_path__ + "assets/7f21bab40ea6a33446cad987d11d02d3.mp3";